<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :width="width">
    <template v-slot>
      <slot></slot>
    </template>
    <template v-slot:footer>
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'FixedDialog',
  props: {
    title: {
      type: String,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  created() {
    this.dialogVisible = this.visible;
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
      if (this.visible) {
        document.documentElement.classList.add('hidden');
      } else {
        document.documentElement.classList.remove('hidden');
      }
    },
    dialogVisible() {
      this.$emit('update:visible', this.dialogVisible);
    },
  },
};
</script>
